import React from 'react';

import { Grid, GridItem } from '@chakra-ui/react';

import styles from './event-card-footer.module.scss';

export const EventCardFooter: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  return (
    <footer className={styles.footer}>
      <Grid templateColumns="repeat(24, 1fr)" gap={0}>
        <GridItem
          className={styles.footerContent}
          colSpan={{ base: 24, sm: 22 }}
          colStart={{ sm: 3 }}
        >
          {children}
        </GridItem>
      </Grid>
    </footer>
  );
};
